import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import InputError from "../../InputError/InputError";
import "./Forms.css";

function CustomTypeAhead({
  id,
  required,
  type,
  formLabel,
  size,
  options,
  name,
  value,
  onChange,
  isError,
  errorMessage = "",
  className,
  disabled,
  onInputChange,
  inputValue,
  onKeyDown,
}) {
  // Function that converts input to uppercase
  const handleInputChange = (inputText) => {
    if (onInputChange) {
      onInputChange(inputText.toUpperCase()); // Convert to uppercase before passing to parent
    }
  };

  // Function to handle selection change
  const handleChange = (selected) => {
    if (onChange && selected.length > 0) {
      // Extract the value from the selected object
      const selectedValue = selected[0];

      // Handle both string and object options
      if (typeof selectedValue === "string") {
        onChange(selectedValue.toUpperCase());
      } else if (selectedValue && typeof selectedValue === "object") {
        // If options are objects, you need to determine which property to use
        // For example, if options have 'value' and 'label' properties:
        const valueToSend = selectedValue.value || selectedValue.label || "";
        onChange(valueToSend.toUpperCase());
      }
    } else if (onChange) {
      onChange(""); // Handle empty selection
    }
  };

  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Typeahead
                id={id}
                options={options}
                selected={value ? [value] : []}
                onChange={handleChange}
                isDisabled={disabled}
                size={size}
                onInputChange={handleInputChange}
                onKeyDown={onKeyDown}
              />
              <InputError
                isValid={isError}
                message={errorMessage !== "" ? errorMessage : "*Required"}
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="align-left form-label">
            {formLabel}
            {required && <span className="badge">*</span>}
          </Form.Label>
          <Typeahead
            id={id}
            options={options}
            selected={value ? [value] : []}
            onChange={handleChange}
            isDisabled={disabled}
            size={size}
            onInputChange={handleInputChange}
            onKeyDown={onKeyDown}
          />
          <InputError
            isValid={isError}
            message={errorMessage !== "" ? errorMessage : "*Required"}
          />
        </Form.Group>
      )}
    </Form>
  );
}

export default CustomTypeAhead;
